<div class="collapsible-section" [class.expanded-wrapper]="isExpanded" >
  <div class="section-header" (click)="onToggle()">
    <div class="section-header-title">
      <h3 class="section-title">{{ title }}</h3>
      <span *ngIf="headerBadge" class="header-badge">{{ headerBadge }}</span>
    </div>
    <div class="section-header-status">
      <span *ngIf="isCompleted" class="completion-check" aria-label="Section completed">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="15" cy="15" r="12" fill="#079271" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19.7511 12.2949L13.3591 18.6894L10.1594 15.4921" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span *ngIf="!isCompleted && !isExpanded" class="toggle-plus" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.99805 1.64844C8.41196 1.64855 8.74773 1.98457 8.74805 2.39844V7.24902H13.5986C14.0126 7.24932 14.3486 7.585 14.3486 7.99902C14.3486 8.41306 14.0126 8.74873 13.5986 8.74902H8.74805V13.5996C8.74776 14.0135 8.41198 14.3495 7.99805 14.3496C7.58412 14.3495 7.24834 14.0135 7.24805 13.5996V8.74902H2.39844C1.98422 8.74902 1.64844 8.41324 1.64844 7.99902C1.64845 7.58482 1.98423 7.24902 2.39844 7.24902H7.24805V2.39844C7.24837 1.98458 7.58414 1.64856 7.99805 1.64844Z" fill="#15172E"/>
        </svg>
      </span>
    </div>
  </div>
  
  <div class="section-content" [class.expanded]="isExpanded" *ngIf="isExpanded">
    <ng-container *ngTemplateOutlet="sectionContent"></ng-container>
    
   
  </div>
</div>
